<div class="srIrops-itinerary-banner">
  <div class="srIrops-itinerary-banner-group1">
    <img class="srIrops-itinerary-banner-img" src="../../../../../assets/images/infoBlue.svg" alt="infoIcon">
    <p class="srIrops-itinerary-banner-textMain" [innerHTML]=" copyTextMain | translate "></p>
  </div>
  <div *ngIf="showButtonChangeFlight">
    <app-button (amClick)="onChangeFlight()" theme="iropsRebrandingBlue" text="{{ copyButtonBanner | translate}}" width="238px" height="60px"></app-button>
  </div>
</div>
